// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2yYVv","loaderOuter":"PageOverlayLoader_loaderOuter__1-o04"};